/* eslint-disable import/prefer-default-export */
export const menuList = [
  {
    id: "integrations",
    name: 'INTERFACES',
  },
  {
    id: "courier",
    name: 'COURIER',
    feature: 'view_courier_integrations'
  },
];

export const successfulItems = [
  { label: 'All Outbound', key: 1, value: 'ALL', columnMap: 'outbound_successful', tlabel: 'INTEGRATION_ALL_OUTBOUND' },
];

export const integrationFilters = [
  { label: 'Modified Picklist', key: 2, value: 'INTEGRATION', columnMap: 'modified_picklist_posting', tlabel: 'MP_POSTING' },
  { label: 'Freight Provision', key: 3, value: 'INTEGRATION', columnMap: 'freight_provision_posting', tlabel: 'FREIGHT_PROVISION' },
  { label: 'EPOD', key: 4, value: 'INTEGRATION', columnMap: 'zpod_posting', tlabel: 'INTEGRATION_EPOD' },
  { label: 'Freight Invoice', key: 5, value: 'INTEGRATION', columnMap: 'freight_invoice_posting', tlabel: 'FREIGHT_INVOICE' },
  { label: 'Shipment Status', key: 10, value: 'INTEGRATION', columnMap: 'shipment_status', tlabel: 'SHIPMENT_STATUS', feature: 'view_shipment_status' },
  { label: 'Discard Optima', key: 11, value: 'INTEGRATION', columnMap: 'discard_optima', tlabel: 'DISCARD_OPTIMA', feature: 'view_discard_optima'},
];

export const successfulCourierItems = [
  { label: 'All', key: 1, value: 'ALL', columnMap: 'all_courier_successfull', tlabel: 'ALL' },
];

export const courierFilters = [
  { label: 'LR Booking', key: 2, value: 'courier', columnMap: 'lr_booking',  tlabel: 'LR_BOOKING'},
  { label: 'LR Cancellation', key: 3, value: 'courier', columnMap: 'lr_cancellation', tlabel: 'LR_CANCELLATION' },
  { label: 'LR Update', key: 4, value: 'courier', columnMap: 'lr_update',  tlabel: 'LR_UPDATE'},
  { label: 'LR Tracking', key: 5, value: 'courier', columnMap: 'lr_tracking', tlabel: 'LR_TRACKING'},
  { label: 'LR POD Fetch', key: 6, value: 'courier', columnMap: 'lr_pod_fetch', tlabel: 'LR_POD_FETCH'},
];

export const integrationInboundFilters = [
  { label: 'Material Invoice', key: 6, value: 'INTEGRATION', columnMap: 'material_invoice', tlabel: 'INTEGRATION_MATERIAL_INVOICE' },
  { label: 'GRN', key: 7, value: 'INTEGRATION', columnMap: 'grn', tlabel: 'INTEGRATION_GRN' },
  { label: 'Bulk Indent', key: 8, value: 'INTEGRATION', columnMap: 'bulk_indent', tlabel: 'INTEGRATION_BULK_INDENT' },
  { label: 'Direct Dispatch', key: 9, value: 'INTEGRATION', columnMap: 'direct_dispatch', tlabel: 'INTEGRATION_DIRECT_DISPATCH' },
];

export const detailsList = [[
  { label: 'API Name', key: 1, value: 'api_name', tlabel: 'INTEGRATION_API_NAME', dataType: 'string' },
  { label: 'Updated date', key: 2, value: 'updated_at', tlabel: 'INTEGRATION_UPDATED_DATE', dataType: 'date' },
  { label: 'MITM Status code', key: 3, value: 'mitm_error_status', tlabel: 'INTEGRATION_MITM_STATUS_code', dataType: 'string' },
  { label: 'MITM Message', key: 4, value: 'mitm_error_msg', tlabel: 'INTEGRATION_MITM_MESSAGE', dataType: 'string' },
  { label: 'MITM URL', key: 5, value: 'mitm_url', tlabel: 'INTEGRATION_MITM_URL', dataType: 'string' },
  { label: 'Erp URL', key: 6, value: 'mitm_url', tlabel: 'INTEGRATION_ERP_URL', dataType: 'string' },
],
[
  { label: 'Entity Id', key: 7, value: 'entity_id', tlabel: 'INTEGRATION_ENTITY_ID', dataType: 'string' },
  { label: 'Entity Type ', key: 8, value: 'entity_type', tlabel: 'INTEGRATION_ENTITY_TYPE', dataType: 'string' },
  { label: 'Erp Status code', key: 9, value: 'erp_status_code', tlabel: 'INTEGRATION_ERP_STATUS_CODE', dataType: 'string' },
  { label: 'Erp Message', key: 10, value: 'erp_error_message', tlabel: 'INTEGRATION_ERP_MESSAGE', dataType: 'string' },
],
];
export const courierDetailsList = [[
  { label: 'API Name', key: 1, value: 'api_name', tlabel: 'INTEGRATION_API_NAME', dataType: 'string' },
  { label: 'Updated date', key: 2, value: 'updated_at', tlabel: 'INTEGRATION_UPDATED_DATE', dataType: 'date' },
  { label: 'Courier Parter Status code', key: 3, value: 'mitm_error_status', tlabel: 'COURIER_PARTNER_STATUS_CODE', dataType: 'string' },
  { label: 'Courier Parter Message', key: 4, value: 'mitm_error_msg', tlabel: 'COURIER_PARTNER_MESSAGE', dataType: 'string' },
  { label: 'Courier Parter URL', key: 5, value: 'mitm_url', tlabel: 'COURIER_PARTNER_URL', dataType: 'string' },
],
[
  { label: 'Indent Number', key: 7, value: 'sub_entity_id', tlabel: 'EXCEPTION_INDENT_NUMBER', dataType: 'string' },
  { label: 'LR Number', key: 7, value: 'entity_id', tlabel: 'INDENT_LR_NUMBER', dataType: 'string' },
  { label: 'Transporter Name', key: 8, value: 'transporter_id', tlabel: 'INDENT_TRANSPORTER_NAME', dataType: 'string', customData: true },
  { label: 'Transporter Id ', key: 9, value: 'transporter_id', tlabel: 'INDENT_TRANSPORTER_ID', dataType: 'string' },
],
];

export const transactionTypes = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
};

export const INTEGRATION_TYPE = { SUCCESSFUL: 1 };

export const searchConstants = [{
  id: 1,
  name: 'EntityId',
  query: 'entity_id',
  tname: 'Entity ID',
  currentQuerySelected: 'Entity ID', // defaultquery option
  multiDropDownQueryOptions: [
    {
      label: 'in Indent',
      typeLabel: 'Indent',
      name: 'Indent',
      query: 'indent',
    },
    {
      label: 'in Invoice',
      typeLabel: 'Invoice',
      name: 'Invoice',
      query: 'invoice',
    },
  ],
},
];

export const courierSearchConstants = [{
  id: 1,
  name: 'Indent Number',
  query: 'sub_entity_id',
  tname: 'Indent Number',
  currentQuerySelected: 'Entity ID', 
},
{
  id: 2,
  name: 'LR Number',
  query: 'entity_id',
  tname: 'INDENT_LR_NUMBER',
  currentQuerySelected: 'LR Number',
},
];
